import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { getUserProfile } from '../store/actions';

class LoggedAppContainer extends Component {
  componentDidMount() {
    this.props.getUserProfile();
  }

  render () {
    return <Switch>
      {this.props.publicRoutes.routes.map(route => (
        <Route {...route} key={route.path} />
      ))}
      {this.props.loggedRoutes.routes.map(route => (
        <Route {...route} key={route.path} />
      ))}
      <Redirect to="/" push />
    </Switch>;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  getUserProfile,
};
LoggedAppContainer.propTypes = {
  publicRoutes: PropTypes.object.isRequired,
  loggedRoutes: PropTypes.object.isRequired,
  getUserProfile: PropTypes.func.isRequired,
};

// withRouter is imported to bypass connect blocking router status
// https://github.com/reactjs/react-redux/issues/507
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoggedAppContainer));
